/**
 * AddRoundCard Component
 * 
 * CTA card to add new custom interview rounds
 */

import React from 'react';
import { Card, Button, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

interface AddRoundCardProps {
  onClick: () => void;
}

const AddRoundCard: React.FC<AddRoundCardProps> = ({ onClick }) => {
  return (
    <Card
      className="add-round-card"
      styles={{ body: { padding: '16px', textAlign: 'center' } }}
      hoverable
      onClick={onClick}
      style={{ cursor: 'pointer', marginTop: 16 }}
    >
      <Button
        type="text"
        icon={<PlusOutlined />}
        size="large"
        style={{ 
          border: 'none', 
          background: 'transparent'
        }}
      >
        <Typography.Text type="secondary" style={{ fontSize: 'var(--ant-font-size-base)' }}>
          Add Custom Round
        </Typography.Text>
      </Button>
    </Card>
  );
};

export default AddRoundCard;
